import { createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/job/edited.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-74b41843")

_pushScopeId("data-v-74b41843")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "card-title display-inline-block" }, "得分:", -1)
const _hoisted_2 = { class: "card-score display-inline-block ml8" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "div" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "card-title display-inline-block" }, "得分:", -1)
const _hoisted_5 = { class: "card-score display-inline-block ml8 tea-see" }
const _hoisted_6 = {
  key: 0,
  class: "c-input"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "img-title ml8" }, "注意：仅可修改一次", -1)
const _hoisted_8 = {
  key: 1,
  class: "c-number"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "img ml8",
  src: _imports_0,
  width: "20"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "div" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "card-title" }, "参考答案:", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "card-title display-inline-block" }, "得分:", -1)
const _hoisted_13 = { class: "card-score display-inline-block ml8" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "div" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "card-title display-inline-block" }, "参考答案:", -1)
const _hoisted_16 = { class: "card-answer display-inline-block ml8" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "card-title" }, "答案解析:", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_CheckOutlined = _resolveComponent("CheckOutlined")

  return (_openBlock(), _createBlock("div", {
    class: ["result", _ctx.questionType === 3 ? "blue" : (_ctx.stuTrue ? "green" : "red")]
  }, [
    (_ctx.questionType === 3)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.cardModel === "stuSee")
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_1,
                _createVNode("div", _hoisted_2, _toDisplayString(_ctx.stuScore || 0) + "分", 1),
                _hoisted_3
              ], 64))
            : (_ctx.cardModel === "teaSee")
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode("div", _hoisted_5, [
                    (_ctx.blankNumber === 0 && !_ctx.isPublish)
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          _createVNode(_component_a_input_number, {
                            class: "input-number",
                            value: _ctx.numberValue,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.numberValue = $event)),
                            min: 0,
                            max: _ctx.score
                          }, null, 8, ["value", "max"]),
                          _createVNode(_component_CheckOutlined, {
                            class: "img ml8",
                            onClick: _ctx.saveBlankScore
                          }, null, 8, ["onClick"]),
                          _hoisted_7
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_8, [
                          _createTextVNode(_toDisplayString(_ctx.stuScore || 0) + "分", 1),
                          _hoisted_9
                        ]))
                  ]),
                  _hoisted_10
                ], 64))
              : _createCommentVNode("", true),
          _hoisted_11,
          _createVNode("div", {
            class: "card-html",
            innerHTML: _ctx.referenceAnswer
          }, null, 8, ["innerHTML"])
        ], 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.jobView === "see")
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                _hoisted_12,
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.stuTrue ? _ctx.score : 0) + "分", 1),
                _hoisted_14
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_15,
          _createVNode("div", _hoisted_16, _toDisplayString(_ctx.referenceAnswer), 1)
        ], 64)),
    _hoisted_17,
    _createVNode("div", {
      class: "card-html",
      innerHTML: _ctx.analysis
    }, null, 8, ["innerHTML"])
  ], 2))
})